import { Mail } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface SourceEmailBadgeProps {
  onClick?: () => void;
  className?: string;
}

export function SourceEmailBadge({ onClick, className }: SourceEmailBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn(
        "cursor-pointer hover:bg-muted transition-colors gap-1",
        className
      )}
      onClick={onClick}
    >
      <Mail className="h-3 w-3" />
      Email
    </Badge>
  );
}
